<template lang="pug">
.events
  .container-fluid.mt-3
    .row.m-0.flex-nowrap.event-carousel(
      @wheel.prevent="mousewheel",
      @scroll="mousewheel(false)",
      ref="carousel"
    )
      .col.event-item(
        v-for="(event, index) in $t('events.events')",
        :key="index",
        :data-index="index",
        :style="{ backgroundImage: 'url(' + getStyle(index).img + ')', color: getStyle(index).clr }",
        :class="{ 'desc-top': getStyle(index).txtPos === 'start', 'desc-bottom': getStyle(index).txtPos === 'bottom', active: index >= currentIndex && index < currentIndex + 3 }"
      )
        .event-item-content(
          :style="{ backgroundColor: getStyle(index).bgClr, borderRadius: '10px' }"
        )
          a.event-item-title(
            :href="event.link",
            :style="{ color: getStyle(index).clr }",
            target="_blank"
          )
            h2(
              :class="{ 'title-en': $i18n.locale === 'en' }",
              v-html="event.desc"
            )
            font-awesome-icon.icon(
              :icon="'external-link-alt'",
              :style="{ fontSize: '1.2rem', display: 'inline-block', marginLeft: '10px' }"
            )
          br
          br
          p(v-if="event.location") {{ event.location }}
          p {{ $t('events.date_dsc') }}: {{ event.date_text }}

    // .row.timeline.m-0
      SvgInline(
        :src="`/timeline.svg`"
        :position="{x: 0, y: 0}" 
        )
    .row.timeline
      .line
      // .cir(:style="{transform: `translateX(${scrollPosX+10}vw)`}")
      .year(v-for="(year, index) in years", :key="index") {{ year.year }}
        .month(
          v-for="(month, idx) in year.months",
          :key="idx",
          :class="{ 'current-month': month === currentMonth }"
        )
          .month-text(@click="clickMonth(month)", v-if="$i18n.locale === 'zh'") {{ month }}月
          .month-text(@click="clickMonth(month)", v-if="$i18n.locale === 'en'") {{ getMonthEn(month) }}
          .evts.d-none.d-lg-block
            .evt(
              v-for="(evt, index) in getMonthEvts(month)",
              @click="clickEvent(evt, index)"
            )
              .evt-name(v-html="evt.desc")
    // :class="{'top': }"
    // , backgroundColor: event.clr, backgroundPositionY: event.pos
</template>

<script>
import SvgInline from "@/components/SvgInline.vue";
import $ from "jquery";
import gsap from "gsap";
import { TweenMax, Power2 } from "gsap";
import { ScrollToPlugin } from "gsap/all";
gsap.registerPlugin(ScrollToPlugin);

export default {
  name: "Events",
  components: {
    SvgInline
  },
  data() {
    return {
      events: [],
      currentIndex: 0,
      currentMonth: 8,
      eventsStyle: [
        {
          index: 0,
          bgClr: "rgba(235,108,80,0.8)",
          clr: "#FFFFFF",
          txtPos: "bottom",
          img: require("@/assets/images/event-0.png")
        },
        {
          index: 1,
          bgClr: "rgba(255,255,255,0.8)",
          clr: "#000000",
          txtPos: "bottom",
          img: require("@/assets/images/event-1.png")
        },
        {
          index: 2,
          bgClr: "rgba(37,119,147,0.8)",
          clr: "#FFFFFF",
          txtPos: "start",
          img: require("@/assets/images/event-2.png")
        },
        {
          index: 3,
          bgClr: "rgba(242,192,60,0.8)",
          clr: "#000000",
          txtPos: "start",
          img: require("@/assets/images/event-3.png")
        },
        {
          index: 4,
          bgClr: "rgba(178,206,96,0.7)",
          clr: "#FFFFFF",
          txtPos: "bottom",
          img: require("@/assets/images/event-4.png")
        }
      ],
      years: [
        {
          year: "2020",
          months: [8, 9, 12]
        },
        {
          year: "2021",
          months: [3]
        }
      ],
      scrollPosX: 0
    };
  },
  mounted() {
    let today = new Date();
    let yearNow = today.getFullYear();
    let monthNow = today.getMonth();
    let dateNow = today.getDate();
    this.clickMonth(monthNow, dateNow, yearNow);
  },
  methods: {
    clickEvent(evt, index) {
      let eventCount = this.$t("events.events").indexOf(evt);
      console.log(eventCount);
      setTimeout(()=>{this.currentMonth = evt.month}, 1100)

      let scrollTime = 0.6;
      let $obj = $(".event-carousel").eq(0);
      let scrollLeft = $obj.scrollLeft();
      let targetScrollLeft = 0;
      if (window.innerWidth > 768) {
        targetScrollLeft = (eventCount * window.innerWidth) / 3;
      } else {
        targetScrollLeft = eventCount * (window.innerWidth - 30);
      }
      //使用Tweenmax 滑動到目標區塊
      let scrollAnimationDuration =
        (scrollTime * Math.abs(targetScrollLeft - scrollLeft)) / 1500;
      TweenMax.to(this, scrollAnimationDuration, {
        scrollPosX: targetScrollLeft,
        ease: Power2.easeOut,
        overwrite: 10
      });
      TweenMax.to($obj, scrollAnimationDuration, {
        scrollTo: { x: targetScrollLeft, autoKill: true },
        ease: Power2.easeOut,
        overwrite: 10
      });
      // console.log(evt, index)
    },
    getMonthEvts(month) {
      let evts = this.$t("events.events").filter(e => {
        if (e.month === month) return e;
      });
      // console.log(evts)
      return evts;
    },
    getMonthEn(month) {
      let monthList = {
        1: "Jan",
        2: "Feb",
        3: "Mar",
        4: "Apr",
        5: "May",
        6: "Jun",
        7: "July",
        8: "Aug",
        9: "Sep",
        10: "Oct",
        11: "Nov",
        12: "Dec"
      };
      return monthList[month];
    },
    getStyle(index) {
      let idx = index % 5;
      return this.eventsStyle[idx];
    },
    mousewheel(event) {
      let browser = (
        this.$store.state.browser.name.replace(/ /g, "_") || ""
      ).toLowerCase();
      let events = Array.from(document.querySelectorAll(".event-item")).map(
        el => {
          let xPos;
          if (browser.includes("edge") || browser.includes("ie")) {
            xPos = el && el.getClientRects()[0].left;
          } else {
            xPos = el && el.getBoundingClientRect().x;
          }
          return {
            el,
            index: 1 * el.getAttribute("data-index"),
            x: xPos
          };
        }
      );
      // console.log(events);
      this.currentIndex = events.find(obj => obj.x > -150).index;
      this.currentMonthIndex =
        window.innerWidth > 768
          ? events.find(obj => obj.x > -window.innerWidth / 3 + 100).index
          : events.find(obj => obj.x > -window.innerWidth + 100).index;
      this.currentMonth = this.$t("events.events")[
        this.currentMonthIndex
      ].month;
      TweenMax.to($(".timeline")[0], 1, {
        scrollTo: { x: $(".current-month").offsetLeft, autoKill: true },
        overwrite: 10
      });
      let $obj = $(".event-carousel").eq(0);
      let scrollLeft = $obj.scrollLeft();
      this.scrollPosX = (100 * finalScroll) / $obj[0].scrollWidth;
      // TweenMax.to( this, scrollTime, {
      //   scrollPosX: ,
      //   ease: Power2.easeOut,
      //   overwrite: 10
      // })
      if (event === false) {
        return;
      }

      let scrollTime = 0.6;
      let scrollDistance = 50;
      event.preventDefault();
      let delta =
        event.wheelDelta / 40 || -event.detail / 0.5 || event.deltaY / 0.9;
      // console.log(scrollLeft)
      let finalScroll = scrollLeft - parseInt(delta * scrollDistance);
      TweenMax.to(this, scrollTime, {
        scrollPosX: (100 * finalScroll) / $obj[0].scrollWidth,
        ease: Power2.easeOut,
        overwrite: 10
      });
      TweenMax.to($obj, scrollTime, {
        scrollTo: { x: finalScroll, autoKill: true },
        ease: Power2.easeOut,
        overwrite: 10
      });
      // console.log(evt)
    },
    clickMonth(month, date = null, year = null) {
      let events = this.$t("events.events");
      let eventCount = 0;

      if (date === null) {
        for (let i = 0; i < events.length; i++) {
          let currentEvent = events[i];
          if (month == currentEvent.month) {
            break;
          } else {
            eventCount += 1;
          }
        }
      } else {
        let targetDate = new Date(year, month, date);
        let eventDates = this.$t("events.events").map(e => {
          return new Date(e.year, e.month - 1, e.date);
        });
        for (let j = 0; j < eventDates.length; j++) {
          if (targetDate <= eventDates[j]) {
            eventCount = j;
            break;
          }
        }
        eventCount = eventCount === 0 ? eventDates.length : eventCount;
      }
      let scrollTime = 1;
      let $obj = $(".event-carousel").eq(0);
      let scrollLeft = $obj.scrollLeft();
      let targetScrollLeft = 0;
      if (window.innerWidth > 768) {
        targetScrollLeft = (eventCount * window.innerWidth) / 3;
      } else {
        targetScrollLeft = eventCount * (window.innerWidth - 30);
      }
      //使用Tweenmax 滑動到目標區塊
      let scrollAnimationDuration =
        (scrollTime * Math.abs(targetScrollLeft - scrollLeft)) / 1500;
      TweenMax.to(this, scrollAnimationDuration, {
        scrollPosX: targetScrollLeft,
        ease: Power2.easeOut,
        overwrite: 10
      });
      TweenMax.to($obj, scrollAnimationDuration, {
        scrollTo: { x: targetScrollLeft, autoKill: true },
        ease: Power2.easeOut,
        overwrite: 10
      });
      setTimeout(() => {
        this.currentMonth = month;
      }, 1100);
    }
  }
};
</script>

<style scoped lang="sass">
$base-color: #036

#months
  display: none
.events
  h2
    display: initial
    font-size: 40px
    font-size: min(4rem,5vmin)
    font-weight: bold
    text-shadow: 0px 0px 30px -10px rgba(black,0.1)
  .datetime
    font-size: 2rem
    font-weight: bold
  &>*
    // border: solid 1px black
  .event-item
    // border: solid 1px black
    // height: calc(100vh - 30px - 80px)
    height: calc(100vh - 30px - 120px)
    flex-shrink: 0
    flex-basis: auto
    width: 33.33vw
    background-repeat: no-repeat
    background-size: cover
    padding: 10px
    display: flex
    flex-direction: column
    align-items: flex-start
    background-position: 50% 100px
    transition: background-position 1.5s
    // box-shadow: 0px 0px 10px rgba(black,0.2)
    .event-item-content
      padding: 15px 10px
      p
        font-size: 1.3rem
        font-weight: bold
        line-height: 1.5
    &>*
      position: relative
      opacity: 0
      transition: 1s
      top: 50px
    &.active
      background-position: 50% 0px
      &>*
        opacity: 1
        top: 0px
    &.desc-top
      justify-content: flex-start
      padding-top: 50px
    &.desc-bottom
      justify-content: flex-end
      padding-bottom: 55px
    .title-en
      font-size: 28px
  .event-carousel
    overflow-x: auto
    overflow-y: hidden
    background-color: #ddd

  .timeline
    transform: translate3d(0, 0, 0)
    position: relative
    height: 150px
    font-weight: bold
    width: 100%
    overflow-x: scroll
    overflow-y: hidden
    .cir
      border-radius: 50%
      position: absolute
      border: solid 2px black
      left: 0
      top: 50%
      width: 20px
      height: 20px

    .line
      position: absolute
      top: 60%
      left: 50%
      transform: translate3d(-40%, -50%, 0)
      // width: calc(100% - 30px)
      width: calc(150%)
      height: 0px
      border-top: 1px solid black
      border-bottom: 1px solid black
    .year
      font-size: 24px
      position: absolute
      width: fit-content
      background-color: white
      left: 25px
      top: 60%
      transform: translate3d(0, -45%, 0)
      border: 10px solid white
      &:nth-last-child(1)
        left: auto
        right: 50px
      .month
        position: absolute
        top: 0
        width: fit-content
        height: 100%
        transition: 0.5s ease-in
        &.current-month::after
          opacity: 1
          content: ''
          position: absolute
          left: 50%
          top: 50%
          width: 20px
          height: 20px
          transform: translate3d(-16%, -60%, 0)
          border: 3px rgba(235, 108, 80, 1) solid
          border-radius: 50%
          transition: 0s ease-in
        .month-text
          font-size: 14px
          position: absolute
          top: -15px
          left: 15px
          width: 50px
          height: 50px
          cursor: pointer
          text-align: right
          transform-origin: 50% 50%
          transform: rotate(330deg) translate3d(-30%, -25%, 0)
        &::before
          content: ''
          position: absolute
          top: 52%
          transform: translate3d(0, -70%, 0)
          width: 15px
          height: 15px
          border-radius: 50%
          background-color: black
        &:hover::before
          transform: scale(1) translate3d(0, -68%, 0)
          transition: 0.5s ease-out
          cursor: pointer
        &.current-month:hover::after
          transform: scale(1) translate3d(-15%, -60%, 0)
          transition: 0.5s ease-out
        &:nth-child(1)
          left: 10vw
        &:nth-child(2)
          left: 30vw
        &:nth-child(3)
          left: 70vw
        // @for $i from 1 through 3
        //   &:nth-child(#{$i})
        //     left: $i * 20vw
        .evts
          // top: -40%
          position: absolute
          top: 0
          left: 0
          width: fit-content
          height: 100%
          transition: 0.5s ease-in
          .evt
            position: absolute
            top: 28%
            width: 12px
            height: 12px
            border-radius: 50%
            background-color: rgba(100,100,100,1)
            .evt-name
              display: none
              z-index: 66777
              position: absolute
              left: 15px
              top: -75px
              width: max-content
              // height: 50px
              min-width: 200px
              font-size: 1.2rem
              background-color: white
              transform-origin: 50% 50%
              // transform: rotate(330deg)
            &:hover
              // transform: scale(1.5)
              cursor: pointer
              .evt-name
                display: initial
                width: max-content
            @for $i from 1 through 10
              &:nth-child(#{$i})
                left: $i * 5vw
            

@media (max-width: 768px)
  .events
    // padding: 0
    // padding-bottom: 100px
    .event-item
      width: 100vw
      transition: 1s
      height: calc(100vh - 80px)
      // padding-bottom: 100px
      h2
        font-size: 3rem
    .timeline
      position: fixed
      top: initial
      right: initial
      left: 0
      bottom: 0
      width: 100vw
      overflow-x: scroll
      margin: 0
      // height: 100px
      height: 70px
      background-color: #ffffff
      box-shadow: 0px 0px 30px rgba(black,0.7)

      .year
        font-size: 18px
        left: 30px
        top: 55%
        transform: translate3d(0, -45%, 0)
        border: 0px solid white
        &:nth-last-child(1)
          left: auto
          right: -20px
        .month
          top: 15%
          @for $i from 1 through 3
            &:nth-child(#{$i})
              left: $i * 22vw

@media (max-height: 800px) and (min-width: 1450px)
  .events .event-item.desc-top
    background-position: 50% -180px
    background-repeat: repeat
</style>
